// extracted by mini-css-extract-plugin
module.exports = {"container":"UserMenu_container__3LleT","name":"UserMenu_name__3q6w7","button":"UserMenu_button__Wd90s"};